<template>
  <div style="width: 100%">
    <el-tabs v-model="activeName">
      <el-tab-pane label="我的成绩" name="first" style></el-tab-pane
    ></el-tabs>
    <div class="boxCell">
      <router-link to="/myscore_list?month=9">
        <div style="display: flex; align-items: center; color: #333">
          <img
            style="width: 50px; height: 50px"
            src="@/assets/image/slogo.png"
            alt=""
          />
          <div style="padding: 5px 20px; flex: 1">
            <h2>9月合肥岗位培训班成绩查询</h2>
            <p style="margin-top: 10px">考试时间：2020-09-27</p>
          </div>

          <el-button type="primary"> 查看成绩 </el-button>
        </div>
      </router-link>
    </div>
    <div class="boxCell">
      <router-link to="/myscore_list?month=11">
        <div style="display: flex; align-items: center; color: #333">
          <img
            style="width: 50px; height: 50px"
            src="@/assets/image/slogo.png"
            alt=""
          />
          <div style="padding: 5px 20px; flex: 1">
            <h2>11月蚌埠岗位培训班成绩查询</h2>
            <p style="margin-top: 10px">考试时间：2020-11-15</p>
          </div>

          <el-button type="primary"> 查看成绩 </el-button>
        </div>
      </router-link>
    </div>

  <div class="boxCell">
      <router-link to="/myscore_list?month=12">
        <div style="display: flex; align-items: center; color: #333">
          <img
            style="width: 50px; height: 50px"
            src="@/assets/image/slogo.png"
            alt=""
          />
          <div style="padding: 5px 20px; flex: 1">
            <h2>12月合肥岗位培训班成绩查询</h2>
            <p style="margin-top: 10px">考试时间：2020-12-27</p>
          </div>

          <el-button type="primary"> 查看成绩 </el-button>
        </div>
      </router-link>
    </div>

    
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      list: [
        {
          name: "安综环引车、辅助",
          url: "https://www.wjx.cn/resultquery.aspx?activity=99109916",
        },
        {
          name: "设备、登录、网管",
          url: "https://www.wjx.cn/resultquery.aspx?activity=99110588",
        },
        {
          name: "外检员",
          url: "https://www.wjx.cn/resultquery.aspx?activity=99109155",
        },
        {
          name: "底盘检验员",
          url: "https://www.wjx.cn/resultquery.aspx?activity=99108885",
        },
        {
          name: "管理岗",
          url: "https://www.wjx.cn/resultquery.aspx?activity=97899600",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.boxCell {
  margin: 10px auto 20px;

  border: 1px solid #e6e6e6;
  padding: 10px 20px;
  width: 700px;
}
</style>